module.exports = __webpack_public_path__ + "assets/img/b002-vu.svg";